/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Icon, Button, FlexRow, FlexCol, Text, DisplayHtmlContent } from 'sarsaparilla';
import * as types from 'ui-permit/src/constants/index';
import InfoModal from 'ui-permit/shared-components/common/InfoModal';
import { RESERVATION_FEE_BY_PERMIT_TYPE } from '../../constants/hunting-permit-constants';
import permitShape from '../../utils/permitShape';
import formatCurrency from '../../utils/formatCurrency';

export default class LotteryReservationDetail extends React.Component {
    static propTypes = {
        selectedDates: PropTypes.arrayOf(PropTypes.shape({})),
        permit: permitShape,
    };

    state = {
        feesModalVisible: false,
    };

    openFeesModal = () => {
        this.setState({ feesModalVisible: true });
    };

    closeFeesModal = () => {
        this.setState({ feesModalVisible: false });
    };

    renderDatePreferenceDetail(date, idx) {
        const selectedDate = date.preferred_date;

        if (gnoment.isGnoment(selectedDate) && selectedDate.isValid()) {
            const key = `${selectedDate.format()}-${idx}`;
            return (
                <div key={key} className="selected-date">
                    <FlexRow>
                        <FlexCol xs={1}>
                            <strong>#{idx + 1}.</strong>
                        </FlexCol>
                        <FlexCol xs={11}>
                            <div className="date">
                                {selectedDate.format(types.DATE_FORMAT)}
                            </div>
                        </FlexCol>
                    </FlexRow>
                </div>
            );
        }

        return null;
    }

    renderLotteryReservationDatesText() {
        const { selectedDates } = this.props;
        return (
            <FlexRow>
                <FlexCol xs={8}>
                    <Text size="sm">Lottery Preferences ({selectedDates.length})</Text>
                </FlexCol>

                {selectedDates.map((date, i) => {
                    if (date && !isEmpty(date.preferred_date)) {
                        return this.renderDatePreferenceDetail(date, i);
                    }
                    // otherwise return preference placeholder until further preference data is received
                    return (
                        <div key={i.toString()} className="selected-date">
                            ---
                        </div>
                    );
                })}
            </FlexRow>
        );
    }

    render() {
        const { permit } = this.props;
        // NOTE: external user can never modify an already paid for application so disregard amount paid
        const total = RESERVATION_FEE_BY_PERMIT_TYPE[permit.id];
        const formattedTotal = formatCurrency(total);
        const feePolicy = get(permit, 'description.fee_policy');

        return (
            <>
                {permit.id === types.BLACKWATER_TURKEY_ID &&
                    this.renderLotteryReservationDatesText()}
                <FlexRow>
                    <FlexCol xs={8}>
                        <Text size="sm">Lottery Application Fee</Text>
                    </FlexCol>
                    <FlexCol className="rec-price-value">
                        <Text size="sm" style={{ textAlign: 'right' }}>
                            {formattedTotal}
                        </Text>
                    </FlexCol>
                </FlexRow>
                <FlexRow>
                    <FlexCol>
                        <Text fontWeight="semibold">
                            Total Cost
                            {!!feePolicy && (
                                <Button
                                    type="button"
                                    onClick={this.openFeesModal}
                                    iconBeforeElement={<Icon iconName="info" />}
                                    screenReaderTextBefore="Open modal for more information about how the total cost is calculated"
                                    appearance="link"
                                    size="xs"
                                />
                            )}
                        </Text>
                    </FlexCol>
                    <FlexCol>
                        <Text fontWeight="semibold" style={{ textAlign: 'right' }}>
                            {formattedTotal}
                        </Text>
                    </FlexCol>
                </FlexRow>
                {feePolicy && (
                    <InfoModal
                        isOpen={this.state.feesModalVisible}
                        closeModal={this.closeFeesModal}
                        title={permit.name && `Fees for the ${permit.name}`}
                    >
                        <DisplayHtmlContent html={feePolicy} />
                    </InfoModal>
                )}
            </>
        );
    }
}
